<div class="banner-variant-wrapper">
    @switch (banner().click_action.action) {
    <!-- link category -->
    @case (ClickActionChoices.link_category) {
    <a [routerLink]="['/category/' + banner().click_action.url_path]">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" class="variant-image" [alt]="banner().title" />
        }
    </a>
    }

    <!-- link product -->
    @case (ClickActionChoices.link_product) {
    <a [routerLink]="['/products/' + banner().click_action.url_path]" [queryParams]="{
      utm_source: 'home',
      utm_medium: 'banner'
    }">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" class="variant-image" [alt]="banner().title" />
        }
    </a>
    }

    <!-- search keywords -->
    @case (ClickActionChoices.search_keywords) {
    <a [routerLink]="['/search']" [queryParams]="{
      q: banner().click_action.value,
      utm_source: 'home',
      utm_medium: 'banner'
    }">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" class="variant-image" [alt]="banner().title" />
        }
    </a>
    }

    <!-- product flags -->
    @case (ClickActionChoices.product_flag) {
    <a [routerLink]="['/search']" [queryParams]="{
      tags: banner().click_action.value,
      utm_source: 'home',
      utm_medium: 'banner'
    }">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" [alt]="banner().title" class="variant-image" />
        }
    </a>
    }

    <!-- link url -->
    @case (ClickActionChoices.link_url) {
    <a [href]="banner().click_action.value" target="_blank">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" class="variant-image" [alt]="banner().title" />
        }
    </a>
    }

    <!-- link product collections -->
    @case (ClickActionChoices.link_collection) {
    <a [routerLink]="['/search']" [queryParams]="{
      collection_ids: banner().click_action.value,
      utm_source: 'home',
      utm_medium: 'banner'
    }">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" [alt]="banner().title" class="variant-image" />
        }
    </a>
    }

    <!-- link brand -->
    @case (ClickActionChoices.link_brand) {
    <a [routerLink]="['/search']" [queryParams]="{
      brand_id: banner().click_action.value,
      brand_name: banner().title,
      utm_source: 'home',
      utm_medium: 'banner'
    }">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" [alt]="banner().title" class="variant-image" />
        }
    </a>
    }

    <!-- none -->
    @case (ClickActionChoices.none) { @if (layoutCardUrl()) {
    <img [src]="layoutCardUrl()" [alt]="banner().title" class="variant-image" />
    } }

    <!-- default to products page -->
    @default {
    <a [routerLink]="['/products']" [queryParams]="{
      utm_source: 'home',
      utm_medium: 'banner'
    }">
        @if (layoutCardUrl()) {
        <img [src]="layoutCardUrl()" class="variant-image" [alt]="banner().title" />
        }
    </a>
    } }
</div>